module.exports = __webpack_public_path__ + "static/ouroboros-game-landing-page-background-da908bcaecff8d0a694976abcd467f79.png";